import { render } from "./Plotting.vue?vue&type=template&id=06c4900d"
import script from "./Plotting.vue?vue&type=script&lang=js"
export * from "./Plotting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__